import React, { memo } from "react";

import { classNames } from "helpers";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import { getVehicleName } from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehicleWizardIntro/helpers";

import { NEW_PRICE_INTRO_SAMPLE } from "../consts";
import { NewPriceSceneProps } from "../types";

/** Korak "Detalji vozila": tehnički podaci o kojima ovise PPMV i PDV. */
const NewPriceDetailsScene: React.FC<NewPriceSceneProps> = ({ formValues, vehicleInfo }) => {
  const co2 = formValues.co2 ?? NEW_PRICE_INTRO_SAMPLE.co2;
  const power = formValues.enginePower ?? NEW_PRICE_INTRO_SAMPLE.enginePower;
  const displacement = (formValues.engineDisplacement ?? NEW_PRICE_INTRO_SAMPLE.engineDisplacement).toLocaleString("hr-HR");
  const seats = formValues.numberOfSeats ?? NEW_PRICE_INTRO_SAMPLE.numberOfSeats;

  const specs = [
    { label: "Emisija CO2", value: `${co2} g/km` },
    { label: "Snaga motora", value: `${power} kW` },
    { label: "Obujam motora", value: `${displacement} ccm` },
    { label: "Broj sjedala", value: `${seats}` },
  ];

  const taxes = [
    { label: "PDV", value: `${NEW_PRICE_INTRO_SAMPLE.vatRate} %`, active: true },
    { label: "PPMV osobna vozila", value: formValues.ppmvPassengerVehicles ? "Da" : "Ne", active: formValues.ppmvPassengerVehicles },
    { label: "Odbitak 50% PDV-a", value: formValues.deduction50PercentVAT ? "Da" : "Ne", active: formValues.deduction50PercentVAT },
  ];

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Detalji vozila</div>
          <div className="text-sm font-bold text-slate-800 truncate">{getVehicleName(vehicleInfo)}</div>
          <div className="mt-3 space-y-2">
            {specs.map((spec) => (
              <div key={spec.label} className="flex items-center justify-between rounded-md bg-slate-50 px-3 py-2">
                <span className="text-[0.7rem] text-slate-500">{spec.label}</span>
                <span className="text-[0.7rem] font-semibold text-slate-800">{spec.value}</span>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Porezi i davanja</div>
          <div className="mt-2 space-y-1.5">
            {taxes.map((tax) => (
              <div key={tax.label} className="flex items-center justify-between gap-2">
                <span className="text-[0.7rem] text-slate-500 truncate">{tax.label}</span>
                <span
                  className={classNames(
                    "px-2 py-0.5 rounded-full text-[0.6rem] font-semibold",
                    tax.active ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-500"
                  )}
                >
                  {tax.value}
                </span>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Emisija određuje PPMV"
          subtitle="Manje CO2 znači manji porez"
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 14l4-4M3.34 19a10 10 0 1117.32 0" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(NewPriceDetailsScene);
